"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const v31_1 = __importDefault(require("./v31"));
const v38_1 = __importDefault(require("./v38"));
const v41_1 = __importDefault(require("./v41"));
const v45_1 = __importDefault(require("./v45"));
const v47_1 = __importDefault(require("./v47"));
// Support archival
const typesBundle = {
    spec: {
        'beresheet': {
            types: [
                {
                    minmax: [10047, undefined],
                    types: v47_1.default.types,
                }
            ]
        },
        'edgeware': {
            alias: {
                voting: { Tally: 'VotingTally' },
            },
            types: [
                // Note that minmax are inclusive on both sides
                {
                    minmax: [0, 31],
                    types: v31_1.default.types,
                }, {
                    minmax: [32, 38],
                    types: v38_1.default.types,
                }, {
                    minmax: [39, 41],
                    types: v41_1.default.types,
                }, {
                    minmax: [42, 46],
                    types: v45_1.default.types,
                }, {
                    minmax: [47, undefined],
                    types: v47_1.default.types,
                },
            ]
        }
    }
};
exports.default = {
    typesBundle
};
